import Vue from 'vue';
import App from './App';
import store from '@/store/index.js';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ClientApi from '@/common/js/bridge/ClientApi.js';
import WebApi from '@/common/js/bridge/WebApi.js';
import { Toast,List,PullRefresh,Lazyload  } from 'vant';
import 'vant/lib/index.css';
import VConsole from 'vconsole';
import { apiUrl } from '@/common/js/base.js';
Vue.use(Toast);
Vue.use(List);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(PullRefresh);

import commonHelper from '@/helpers/commonHelper';
Vue.prototype.$appCommonH = commonHelper;

Vue.prototype.ClientApi = ClientApi;
Vue.prototype.WebApi = WebApi;

import '@/common/js/axios.js';

import '@/common/scss/common.scss';
import '@/common/scss/icon.scss';

Vue.config.productionTip = false;

Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
  if (!store.state.jsUrl) {
    store.commit('SET_WX_JS_URL', document.URL);
  }
  next();
});
let url = location.href;
console.log(apiUrl.vConsole,'===========apiUrl.vConsole')
// || (location.href.includes('activity.szjiyun.com') && commonHelper.isAlipayMiniProgram())
if (apiUrl.vConsole || url.indexOf('isDebug') >= 0 ) {
  let vConsole = new VConsole();
}
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js